"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoteOutlineIcon = exports.NoteFilledIcon = exports.AgentIcon = void 0;
const react_1 = __importDefault(require("react"));
const SvgIcon_1 = __importDefault(require("@material-ui/core/SvgIcon"));
/**
 * Displays a real estate agent icon
 */
const AgentIcon = (props) => {
    return (react_1.default.createElement(SvgIcon_1.default, Object.assign({}, props, { viewBox: "0 0 48 48" }),
        react_1.default.createElement("path", { d: "M38.5 30.25v-16.1L28 6.8l-10.5 7.35v6.45h-3v-7.95L28 3l13.5 9.65v17.6ZM28 6.8ZM29 17h2v-2h-2Zm-4 0h2v-2h-2Zm4 4h2v-2h-2Zm-4 0h2v-2h-2Zm3.3 23.9-15.55-4.45v2.85H2V23.6h15.45l12.75 4.8q1.35.5 2.275 1.625.925 1.125.925 3.225h5.7q2.1 0 3.5 1.5T44 38.8v1.3ZM5 40.3h4.7V26.6H5Zm23.1 1.5 12.8-3.9q-.3-.95-.75-1.3-.45-.35-1.05-.35H28.75q-1.5 0-2.775-.2t-2.425-.55l-4.05-1.25 1.1-2.9 3.65 1.2q1.25.4 2.375.55 1.125.15 3.575.15 0-.6-.225-1.175-.225-.575-.775-.825L16.95 26.6h-4.2v10.7ZM9.7 33.45Zm20.5-.2Zm-20.5.2Zm3.05 0Z" })));
};
exports.AgentIcon = AgentIcon;
/**
 * Displays a filled note icon
 */
const NoteFilledIcon = (props) => {
    return (react_1.default.createElement(SvgIcon_1.default, Object.assign({}, props, { viewBox: "0 0 18 18" }),
        react_1.default.createElement("path", { d: "M16.92 10.1944L16.0575 9.33187C15.615 8.88938 14.9025 8.88938 14.4675 9.33187L10.5 13.2994V15.7519H12.9525L16.92 11.7844C17.3625 11.3419 17.3625 10.6294 16.92 10.1944ZM12.435 14.5894H11.6625V13.8169L14.25 11.2294L15.0225 12.0019L12.435 14.5894Z" }),
        react_1.default.createElement("path", { d: "M3 2.25H12C12.825 2.25 13.5 2.925 13.5 3.75V8.17758L9 12.6772V15.75H3C2.175 15.75 1.5 15.075 1.5 14.25V3.75C1.5 2.925 2.175 2.25 3 2.25Z" })));
};
exports.NoteFilledIcon = NoteFilledIcon;
/**
 * Displays an outlined note icon
 */
const NoteOutlineIcon = (props) => {
    return (react_1.default.createElement(SvgIcon_1.default, Object.assign({}, props, { viewBox: "0 0 24 24" }),
        react_1.default.createElement("path", { d: "M22.56 13.5925L21.41 12.4425C20.82 11.8525 19.87 11.8525 19.29 12.4425L14 17.7325V21.0025H17.27L22.56 15.7125C23.15 15.1225 23.15 14.1725 22.56 13.5925ZM16.58 19.4525H15.55V18.4225L19 14.9725L20.03 16.0025L16.58 19.4525Z" }),
        react_1.default.createElement("path", { d: "M16 12.9033V5H4V19H12V21H4C2.9 21 2 20.1 2 19V5C2 3.9 2.9 3 4 3H16C17.1 3 18 3.9 18 5V10.9034L16 12.9033Z" })));
};
exports.NoteOutlineIcon = NoteOutlineIcon;
